import React from 'react';
import { v4 as uuid } from 'uuid';
import { PropertyType } from 'esa-ui-library/lib/types';

export const getRows = (history: PropertyType[]): PropertyType[] => {
	const data = history.map((h) => [
		<span key={uuid()}>{h.ip || '- -'}</span>,
		<span key={uuid()}>{h.times_used || '- -'}</span>,
		<span key={uuid()}>{h.last_date || '- -'}</span>,
	]);
	return data;
};
